import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints } from '@/styles'

import { SectionTitle, SectionWrapper } from '../elements'
import QuestionCard from './question-card'
import BookADemo from './images/book-a-demo.png'
import CustomerSupport from './images/customer-support.png'
import ListingAssessment from './images/listing-assessment.png'

const Wrapper = styled(SectionWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 772px;
`

const ResourceCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 32px;
  padding-top: 56px;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: 1fr;
  }
`

const Resources = () => {
  const { t } = useTranslation('landlords')
  return (
    <Wrapper>
      <TitleWrapper>
        <SectionTitle>{t('landlords:Got Questions?')}</SectionTitle>
      </TitleWrapper>
      <ResourceCardWrapper>
        <QuestionCard
          title={t('landlords:Customer Support')}
          text={t(
            'landlords:Need assistance? Our support team has you covered.'
          )}
          imgSrc={CustomerSupport}
          cardId="chat"
          linkText={t('landlords:Contact Support')}
          resourceHref="mailto:support@liv.rent?subject=Support Request: Assistance Needed"
        />
        <QuestionCard
          title={t('landlords:Book a Demo')}
          text={t(
            'landlords:Get the most out of liv.rent’s all-in-one landlord features.'
          )}
          imgSrc={BookADemo}
          cardId="book-demo"
          linkText={t('landlords:Book a Demo')}
          resourceHref="https://calendly.com/livrent/30min-educational-session?month=2023-06"
        />
        <QuestionCard
          title={t('landlords:Listing Assessment')}
          text={t('landlords:Find out exactly how much your listing is worth.')}
          imgSrc={ListingAssessment}
          cardId="assess"
          linkText={t('landlords:Try Listing Assessment')}
          resourceHref="https://landlords.liv.rent/rentestimate/"
        />
      </ResourceCardWrapper>
    </Wrapper>
  )
}

export default Resources
